const COLORS = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven'
];

export function setHtmlClass(colorId) {
  const className = document.documentElement.className;
  let newClassName = className;
  // Check if there's a class, if so remove it
  if (className.endsWith('-bg')) {
    newClassName = className.substring(0, className.lastIndexOf(' '));
  }
  // Append the new -bg class
  newClassName += ` ${COLORS[colorId]}-bg`;
  // Add class to HTML DOM
  document.documentElement.className = newClassName;
}
